interface Prefecture {
  src: string;
  matched: boolean;
  alt: string;
}

export const cardImages: Prefecture[] = [
  { src: "/images/aomori.jpg", matched: false, alt: "Aomori_Prefecture" },
  { src: "/images/aichi.jpg", matched: false, alt: "Aichi_Prefecture" },
  { src: "/images/akita.jpg", matched: false, alt: "Akita_Prefecture" },
  { src: "/images/aomori.jpg", matched: false, alt: "Aomori_Prefecture" },
  { src: "/images/chiba.jpg", matched: false, alt: "Chiba_Prefecture" },
  { src: "/images/Ehime.jpg", matched: false, alt: "Ehime_Prefecture" },
  { src: "/images/fukui.jpg", matched: false, alt: "Fukui_Prefecture" },
  { src: "/images/fukuoka.jpg", matched: false, alt: "Fukuoka_Prefecture" },
  { src: "/images/fukushima.jpg", matched: false, alt: "Fukushima_Prefecture" },
  { src: "/images/gifu.jpg", matched: false, alt: "Gifu_Prefecture" },
  { src: "/images/gunma.jpg", matched: false, alt: "Gunma_Prefecture" },
  { src: "/images/hiroshima.png", matched: false, alt: "Hiroshima_Prefecture" },
  { src: "/images/hokkaido.jpg", matched: false, alt: "Hokkaido_Prefecture" },
  { src: "/images/hyogo.jpg", matched: false, alt: "Hyogo_Prefecture" },
  { src: "/images/ibaraki.jpg", matched: false, alt: "Ibaraki_Prefecture" },
  { src: "/images/ishikawa.jpg", matched: false, alt: "Ishikawa_Prefecture" },
  { src: "/images/iwate.jpg", matched: false, alt: "Iwate_Prefecture" },
  { src: "/images/kagawa.jpg", matched: false, alt: "Kagawa_Prefecture" },
  { src: "/images/kagoshima.jpg", matched: false, alt: "Kagoshima_Prefecture" },
  { src: "/images/kanagawa.jpg", matched: false, alt: "Kanagawa_Prefecture" },
  { src: "/images/kochi.jpg", matched: false, alt: "Kochi_Prefecture" },
  { src: "/images/kumamoto.jpg", matched: false, alt: "Kumamoto_Prefecture" },
  { src: "/images/kyoto.jpg", matched: false, alt: "Kyoto_Prefecture" },
  { src: "/images/miyagi.jpg", matched: false, alt: "Miyagi_Prefecture" },
  { src: "/images/mie.jpg", matched: false, alt: "Mie_Prefecture" },
  { src: "/images/miyazaki.jpg", matched: false, alt: "Miyazaki_Prefecture" },
  { src: "/images/nagano.jpg", matched: false, alt: "Nagano_Prefecture" },
  { src: "/images/nagasaki.jpg", matched: false, alt: "Nagasaki_Prefecture" },
  { src: "/images/nara.jpg", matched: false, alt: "Nara_Prefecture" },
  { src: "/images/niigata.jpg", matched: false, alt: "Niigata_Prefecture" },
  { src: "/images/oita.jpg", matched: false, alt: "Oita_Prefecture" },
  { src: "/images/okayama.jpg", matched: false, alt: "Okayama_Prefecture" },
  { src: "/images/okinawa.jpg", matched: false, alt: "Okinawa_Prefecture" },
  { src: "/images/osaka.jpg", matched: false, alt: "Osaka_Prefecture" },
  { src: "/images/saga.jpg", matched: false, alt: "Saga_Prefecture" },
  { src: "/images/saitama.jpg", matched: false, alt: "Saitama_Prefecture" },
  { src: "/images/shiga.jpg", matched: false, alt: "Shiga_Prefecture" },
  { src: "/images/shimane.jpg", matched: false, alt: "Shimane_Prefecture" },
  { src: "/images/shizuoka.jpg", matched: false, alt: "Shizuoka_Prefecture" },
  { src: "/images/tochigi.jpg", matched: false, alt: "Tochigi_Prefecture" },
  { src: "/images/tokushima.jpg", matched: false, alt: "Tokushima_Prefecture" },
  { src: "/images/tokyo.jpg", matched: false, alt: "Tokyo_Prefecture" },
  { src: "/images/tottori.jpg", matched: false, alt: "Tottori_Prefecture" },
  { src: "/images/toyama.jpg", matched: false, alt: "Toyama_Prefecture" },
  { src: "/images/wakayama.jpg", matched: false, alt: "Wakayama_Prefecture" },
  { src: "/images/yamagata.jpg", matched: false, alt: "Yamagata_Prefecture" },
  { src: "/images/yamaguchi.jpg", matched: false, alt: "Yamaguchi_Prefecture" },
  { src: "/images/yamanashi.jpg", matched: false, alt: "Yamanashi_Prefecture" },
];
